import { render, staticRenderFns } from "./shiPei.vue?vue&type=template&id=64c0adb0&scoped=true"
import script from "./shiPei.vue?vue&type=script&lang=js"
export * from "./shiPei.vue?vue&type=script&lang=js"
import style0 from "./shiPei.vue?vue&type=style&index=0&id=64c0adb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c0adb0",
  null
  
)

export default component.exports